export const inDebug = () => {
  return localStorage.getItem('_cart_debug_') == 1;
}
/** 是否在鸿蒙app内部 */
export const inHarmonyApp = () => {
  return window?.apputils?.isHarmonyOS;
  // const ua = navigator.userAgent.toLowerCase()
  // const inAPP = /lenovoofficialapp/i.test(ua);
  // const inHarmonyApp = ua?.indexOf('harmony') > -1;
  // return inAPP&&inHarmonyApp;
}

export const inAPP = () => {
  const inAPP = /lenovoofficialapp/i.test(ua);
  return inAPP;
}